import { render } from "./categories.vue?vue&type=template&id=7c27d77a&scoped=true"
import script from "./categories.js?vue&type=script&lang=js&external"
export * from "./categories.js?vue&type=script&lang=js&external"

import "./categories.css?vue&type=style&index=0&id=7c27d77a&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c27d77a"]])

export default __exports__